import * as React from 'react';
import { Component, deps, inject, observer } from '../lib/component';
import { AccountLayout } from '../components/account/layout';
import { AccountChannels } from '../components/account/channels';
import { style } from 'typestyle';
import { endJustified, horizontal } from 'csstips';
import {ButtonPill} from '../components/button-pill';

export interface AccountChannelsPageProps {

}

@inject(deps) @observer
export class AccountChannelsPage extends Component<AccountChannelsPageProps> {
  render() {
    const { loading, channels = [] } = this.props.model.page.accountChannels;

    return (
      <AccountLayout>
        <div className={AccountChannelsPage.styles.actions}>
          <ButtonPill onClick={this.props.controller.modal.showChannelAddModal}>
            Add channel
          </ButtonPill>
        </div>
        <AccountChannels
          loading={loading}
          channels={channels}
        />
      </AccountLayout>
    )
  }

  static styles = {
    actions: style({
      ...horizontal,
      ...endJustified,
      margin: '0 0 30px 0'
    })
  }
}